import React, { useEffect } from 'react'
import NavBar from './components/NavBar'
import { matchRoutes, MatchedRoute, renderRoutes } from 'react-router-config'
import { BreadcrumbContext } from '@/components/Breadcrumb/BreadcrumbContext'
import ErrorBoundary from './components/ErrorBoundary'
import styles from './index.module.less'
import { useSocket } from '@/hooks'
import { insertIntercom, shutdownIntercom } from '@/utils/intercom'
import { CompleteGuideModal } from '@/bizComponents/Guide/CompleteGuideModal'
import { GiveawayModal } from '@/bizComponents/Giveaway'
import { useCookieSdk } from '@/hooks/useCookieSdk'
import { FreeActivityIcon } from '@/bizComponents/Giveaway/FreeActivityIcon'

const PrimaryLayout = (props) => {
  const { route, location } = props

  // Cookie UK
  useCookieSdk()

  // 接入socket
  useSocket()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    insertIntercom()
    return () => {
      shutdownIntercom()
    }
  }, [])

  const matchedRoutes: MatchedRoute<string>[] = matchRoutes([route], location.pathname)
  const currentRoute = matchedRoutes[matchedRoutes.length - 1].route

  return (
    <div className={styles.root}>
      <ErrorBoundary>
        <BreadcrumbContext.Provider value={matchedRoutes}>
          <NavBar routes={route.routes} />
          {renderRoutes(route.routes)}
          <FreeActivityIcon />
        </BreadcrumbContext.Provider>
      </ErrorBoundary>
      {!currentRoute.noModal && (
        <>
          <CompleteGuideModal />
          {/* 活动优惠领取弹窗 */}
          <GiveawayModal />
        </>
      )}
    </div>
  )
}

export default PrimaryLayout
